import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const ActionLogin = createSvgIcon(
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <g strokeWidth="1" strokeOpacity=".2" stroke="currentColor">
      <rect width="40" height="40" strokeWidth="2" strokeOpacity=".4" />
      {[...Array(40)].map((_, i) => (
        <line key={`n-${i}`} x1={i * 2} x2={-40 + i * 2} y1="0" y2="40" />
      ))}
    </g>
  </svg>,
  'ActionLogin'
);
